import React, { useMemo, useState } from "react";
import styled from "styled-components";
import { Icon } from "@iconify/react";
import { sortRows } from "../../utils/appData";

// Client-side column sorting for the app data tables. Rows default to newest first.

const HeaderButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 0;
  border: none;
  background: transparent;
  color: inherit;
  font: inherit;
  text-transform: inherit;
  letter-spacing: inherit;
  text-align: left;
  cursor: pointer;
`;

/**
 * @param {object[]} rows
 * @param {object} [options]
 * @param {string} [options.initialKey]
 * @param {"asc"|"desc"} [options.initialDir]
 */
export const useSort = (rows = [], { initialKey = "updated_at", initialDir = "desc" } = {}) => {
  const [sortKey, setSortKey] = useState(initialKey);
  const [sortDir, setSortDir] = useState(initialDir);

  const toggle = (key) => {
    if (key === sortKey) {
      setSortDir((current) => (current === "asc" ? "desc" : "asc"));
      return;
    }

    setSortKey(key);
    // Dates read best newest-first; everything else ascending.
    setSortDir(key === "updated_at" ? "desc" : "asc");
  };

  const sorted = useMemo(() => sortRows(rows, sortKey, sortDir), [rows, sortKey, sortDir]);

  return { sorted, sortKey, sortDir, toggle };
};

/** A sortable column header. */
export const SortHeader = ({ label, column, activeKey, dir, onToggle }) => {
  const active = column === activeKey;

  return (
    <HeaderButton type="button" onClick={() => onToggle(column)} title={`Sort by ${label}`}>
      {label}
      {active ? (
        <Icon
          icon={dir === "asc" ? "lucide:arrow-up" : "lucide:arrow-down"}
          style={{ fontSize: "11px" }}
        />
      ) : null}
    </HeaderButton>
  );
};

export default useSort;
